import React from "react";
import { Box } from "@mui/material";
import theme from "../../../../../Layouts/theme";

const ColumnDropIndicator = ({ visible }) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        width: "4px",
        minWidth: "4px",
        alignSelf: "stretch",
        backgroundColor: theme.palette.primary.main,
        borderRadius: "2px",
        marginLeft: "-9px",
        marginRight: "-9px",
        zIndex: 10,
        boxShadow: `0 0 8px ${theme.palette.primary.main}`,
      }}
    />
  );
};

export default ColumnDropIndicator;
